export default "__VITE_ASSET__BYPH6KfG__"